import { Component } from "react";
import withAuth from "../../../components/withAuth";
import { compose } from "redux";
import { connect } from "react-redux";
import { setHeader } from "../../../redux/analyseRisques/analyseRisquesActions";
import { clone } from "../../../utils";
import ParticipantCard from "../../../components/AnalyseRisques/ParticipantCard";
import { arIsReadonly } from "../../../redux/analyseRisques/analyseRisquesStatusActions";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "moment/locale/fr";
import { TYPING_TIMEOUT } from "../../../constants";
import CustomizedTextField from "../../../components/Input/CustomizedTextField";
import DatePicker from "../../../components/Input/DatePicker";

class AnalyseRisquesICP extends Component {
	constructor(props) {
		super(props);
		this.state = {
			communicatedInformation: props.header.communicatedInformation,
			icpParticipants: props.header.icpParticipants,
			communicatedInformationTypingTimeout: null,
			icpParticipantsTypingTimeout: null,
			participants: props.currentParticipants,
			timeout: TYPING_TIMEOUT,
		};
	}

	componentDidMount() {
		this.updateParticipants(this.props);
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		let modifiedState = prevState;
		modifiedState.participants = nextProps.currentParticipants;
		return modifiedState;
	}

	onJointInspectionDateChange(value) {
		const header = clone(this.props.header);
		header.jointInspectionDate = value;
		this.props.setHeader(header);
	}

	onCommunicatedInformationChange(event) {
		let value = event.target.value;

		if (this.state.communicatedInformationTypingTimeout) {
			clearTimeout(this.state.communicatedInformationTypingTimeout);
		}

		this.setState({
			communicatedInformation: value,
			communicatedInformationTypingTimeout: setTimeout(() => {
				const header = clone(this.props.header);
				header.communicatedInformation = value;
				this.props.setHeader(header);
			}, this.state.timeout),
		});
	}

	onIcpParticipantsChange(event) {
		let value = event.target.value;

		if (this.state.icpParticipantsTypingTimeout) {
			clearTimeout(this.state.icpParticipantsTypingTimeout);
		}

		this.setState({
			icpParticipants: value,
			icpParticipantsTypingTimeout: setTimeout(() => {
				const header = clone(this.props.header);
				header.icpParticipants = value;
				this.props.setHeader(header);
			}, this.state.timeout),
		});
	}

	updateParticipants(props) {
		let participants = props.currentParticipants;
		/*.slice(0, 2);

        for (let i = 0; i < props.currentParticipants.length; i++) {
            props.risks.forEach((r) => {
                r.solutions.forEach((s) => {
                    let concernedCompanyNotFoundYet = s.concernedCompanies.find(cc => cc.company.type.id === props.currentParticipants[i].typeId
                        && !participants.find((participant) => participant.typeId === cc.company.type.id))

                    if(concernedCompanyNotFoundYet && concernedCompanyNotFoundYet.concerned){
                        participants.push(props.currentParticipants[i]);
                    }
                })
            })
        }*/

		this.setState({
			participants,
		});
	}

	render() {
		let participants = [];
		let index = 0;

		this.state.participants.forEach((p) => {
			participants.push(<ParticipantCard key={index} currentParticipant={p} currentParticipantIndex={index} />);
			index++;
		});

		//participants.push(<ParticipantCard key={index} currentParticipant={getDefaultParticipant(0, this.props.currentParticipants)} currentParticipantIndex={index}/>);

		return (
			<div className="row">
				<Card
					className={
						"card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding " +
						(arIsReadonly(this.props.header) ? "disabled" : "")
					}
				>
					<CardContent>
						<div className="row full-height">
							<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
								<DatePicker
									value={new Date(this.props.header.jointInspectionDate)}
									label={"Date d'inspection commune préalable"}
									id="joint-inspection-date"
									emptyLabel="La date est invalide"
									invalidDateMessage="La date est invalide"
									invalidLabel="La date est invalide"
									format="DD/MM/YYYY"
									className={
										"col-lg-12 col-md-12 col-sm-12 col-12 " +
										(this.props.readonly ? "disabled" : "")
									}
									onChange={this.onJointInspectionDateChange.bind(this)}
								/>
							</div>
							<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
								<CustomizedTextField
									id="icp-participants"
									label={"Participants"}
									className="full_size"
									multiline
									required={this.props.moduleSpp}
									value={this.state.icpParticipants}
									onChange={this.onIcpParticipantsChange.bind(this)}
								/>
							</div>
							<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
								<CustomizedTextField
									id="communicated-information"
									label={"Information communiquée"}
									className="full_size"
									multiline
									value={this.state.communicatedInformation}
									onChange={this.onCommunicatedInformationChange.bind(this)}
								/>
							</div>
						</div>
					</CardContent>
				</Card>
				<div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">{participants}</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		header: state.analyseRisques.header,
		risks: state.analyseRisques.risks,
		currentParticipants: state.analyseRisques.participants,
		moduleSpp: state.analysesRisques.moduleSpp,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setHeader: (header) => dispatch(setHeader(header)),
	};
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(AnalyseRisquesICP);
